import React from "react";
import CustomPicky from "./CustomPicky";

const WorkersMultiSelect = ({
  currentPage,
  isShowingWorkers,
  workers,
  selectedWorkersObjects,
  onSelectWorkers,
}) => {
  const isMulti = currentPage !== "Hours";
  const disablePages = currentPage === "Dashboard" || currentPage === "Hours";

  return (
    <CustomPicky
      key={`workers-${workers?.length || 0}-${currentPage}`}
      className={!isShowingWorkers && disablePages ? "picky_disabled" : ""}
      options={workers}
      value={
        isMulti && !Array.isArray(selectedWorkersObjects)
          ? [selectedWorkersObjects]
          : selectedWorkersObjects
      }
      multiple={isMulti}
      onChange={onSelectWorkers}
      placeholder="Select worker"
      disabled={!isShowingWorkers && disablePages}
    />
  );
};

export default WorkersMultiSelect;
